import {
	GROUP_TYPE,
	GROUP_SECTION_WIDTH,
	drawRectangle,
	GROUP_SECTION_SPACING_LEVEL_FOUR,
	GROUP_SECTION_PADDING_LEFT,
	drawBorder,
	GROUP_SECTION_PROJECT_BORDER_WIDTH,
	GROUP_SECTION_MARGIN_LEFT,
	GROUP_SECTION_TEXT_GREY_LIGHT,
} from '../../canvas-timeline/canvas_timeline_util';
import Group from '../../canvas-timeline/canvas_timeline_group';
import {cacheManager} from '../../canvas-timeline/canvas_timeline_cache_manager';
import Util from '../../../../forecast-app/shared/util/util';
import {hasFeatureFlag} from "../../../../forecast-app/shared/util/FeatureUtil";

class PlaceholderGroup extends Group {
	constructor(data) {
		super(GROUP_TYPE.PROJECT_SCHEDULING_PLACEHOLDER, data);
	}

	draw(canvasContext, x, y) {
		if (hasFeatureFlag("timeline_group_section_restyling")) {
			const width = GROUP_SECTION_WIDTH();
			const {data, height, groupType} = this;
			super.draw(x, y, width, height, this);
			const {id, color, isInProjectGroup, projectGroupColor} = data;
			const cacheId = `${groupType}-${id}`;
			const cachedData = cacheManager.get(groupType, cacheId);
			const borderThickness = 1;

			if (cachedData) {
				canvasContext.drawImage(cachedData, x, y, width, this.itemRowHeight);
				return;
			}

			const offsetX = isInProjectGroup
				? GROUP_SECTION_SPACING_LEVEL_FOUR
				: GROUP_SECTION_SPACING_LEVEL_FOUR - GROUP_SECTION_PADDING_LEFT;

			drawRectangle(
				canvasContext,
				x + offsetX,
				y - 1,
				width - offsetX,
				height + 1,
				{
					backgroundColor: '#ffffff',
				}
			);

			// draw left connected project border color
			if (isInProjectGroup && projectGroupColor) {
				drawBorder(
					canvasContext,
					x + GROUP_SECTION_MARGIN_LEFT - GROUP_SECTION_PROJECT_BORDER_WIDTH,
					y - 2 - (borderThickness * 2),
					height + (borderThickness * 2),
					true,
					projectGroupColor,
					GROUP_SECTION_PROJECT_BORDER_WIDTH,
				);
			}

			// right project color
			if (!isInProjectGroup) {
				drawBorder(
					canvasContext,
					x + width - GROUP_SECTION_PROJECT_BORDER_WIDTH,
					y - 2 - (borderThickness * 2),
					height + (borderThickness * 2),
					true,
					color,
					GROUP_SECTION_PROJECT_BORDER_WIDTH,
				);
			}

			// placeholder text
			const fontSize = 11;
			canvasContext.fillStyle = GROUP_SECTION_TEXT_GREY_LIGHT;
			canvasContext.font = `500 ${fontSize}px ` + Util.getFontFamily();
			canvasContext.fillText(
				data.name,
				x + offsetX + GROUP_SECTION_PADDING_LEFT,
				y + (height / 2) + (fontSize / 3)
			);
		} else {
			const width = GROUP_SECTION_WIDTH();
			const {data, height, groupType} = this;
			super.draw(x, y, width, height, this);
			const {id} = data;
			const cacheId = `${groupType}-${id}`;
			const cachedData = cacheManager.get(groupType, cacheId);

			if (cachedData) {
				canvasContext.drawImage(cachedData, x, y, width, this.itemRowHeight);
				return;
			}

			drawRectangle(canvasContext, x + data.xOffset, y - 1, width - data.xOffset, height + 1, {
				borderColor: '#ebebee',
				borderThickness: 1,
				backgroundColor: '#ffffff',
			});
			canvasContext.font = '14px ' + Util.getFontFamily();
			canvasContext.fillStyle = '#a1a1a1';
			canvasContext.font = 'italic 12px ' + Util.getFontFamily();
			canvasContext.fillText(data.name, x + 24, y + 18);
		}
	}
}

export default PlaceholderGroup;
